var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      attrs: { "data-title": "核心风险" }
    },
    [
      _c("div", { staticClass: "sms-content-main" }, [
        _c(
          "div",
          { ref: "coreRiskBox", staticClass: "core-risk-box" },
          _vm._l(_vm.cardData, function(item) {
            return _c(
              "div",
              {
                key: item.code,
                staticClass: "sms-cell-box",
                class: { "card-active": _vm.coreRisk.code === item.code },
                on: {
                  click: function($event) {
                    return _vm.onCardClick(item)
                  }
                }
              },
              [_c("CoreRiskCard", { attrs: { "core-risk": item } })],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "core-risk-month" },
          [
            _c("div", { staticClass: "sms-module-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.coreRisk.name) +
                  "-月度管控状态\n        "
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "el-date-picker-wrapper year-wrapper" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "year",
                      format: "yyyy年",
                      "value-format": "yyyy",
                      clearable: false,
                      editable: false,
                      placeholder: "选择年"
                    },
                    model: {
                      value: _vm.year,
                      callback: function($$v) {
                        _vm.year = $$v
                      },
                      expression: "year"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.coreRisk.code
              ? _c("CoreRiskMonth", {
                  attrs: { coreRisk: _vm.coreRisk.code, year: Number(_vm.year) }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "core-risk-danger" }, [
          _c("div", { staticClass: "sms-module-header" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.coreRisk.name) + "-关联危险源\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "risk-table-box" },
            [
              _vm.coreRisk.code
                ? _c("CoreRiskDanger", {
                    attrs: {
                      coreRisk: _vm.coreRisk.code,
                      danger: _vm.danger,
                      insecurity: _vm.insecurity
                    },
                    on: {
                      "update:danger": function($event) {
                        _vm.danger = $event
                      },
                      "update:insecurity": function($event) {
                        _vm.insecurity = $event
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "core-risk-kpi" }, [
          _c("div", { staticClass: "sms-module-header" }, [
            _c(
              "div",
              {
                staticClass: "kpi-prefix-box",
                class: { "kpi-prefix-box-dynamic": _vm.kpi.prefix.remove }
              },
              [
                _c("p", [_vm._v(_vm._s(_vm.kpi.prefix.name))]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-error",
                  on: { click: _vm.removeKpiPrefix }
                })
              ]
            ),
            _vm._v("\n        -关联KPI指标\n      ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "risk-table-box" },
            [
              _vm.coreRisk.code && _vm.kpi.enable
                ? _c("CoreRiskKpi", {
                    attrs: {
                      coreRisk: _vm.coreRisk.code,
                      dangerId: _vm.danger.id,
                      year: Number(_vm.year),
                      insecurity: _vm.insecurity.code,
                      kpiCode: _vm.kpi.code
                    },
                    on: {
                      "update:kpiCode": function($event) {
                        return _vm.$set(_vm.kpi, "code", $event)
                      },
                      "update:kpi-code": function($event) {
                        return _vm.$set(_vm.kpi, "code", $event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.kpi.code
        ? _c("div", { staticClass: "sms-content-main" }, [
            _c(
              "div",
              { staticClass: "core-risk-warn", attrs: { id: "kpiChart" } },
              [
                _c("KpiChart", {
                  attrs: { kpiCode: _vm.kpi.code, year: Number(_vm.year) }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-967bb9c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-967bb9c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/CoreRisk.vue
// module id = null
// module chunks = 